"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getBtcPaymentUrl = void 0;
const ethers_1 = require("ethers");
const payment_detection_1 = require("@requestnetwork/payment-detection");
const utils_1 = require("./utils");
/**
 * Returns the BIP21 payment URL based on the Request's value
 * @param amount optionally, the amount to pay. Defaults to remaining amount of the request.
 */
function getBtcPaymentUrl(request, amount) {
    const pn = (0, payment_detection_1.getPaymentNetworkExtension)(request);
    const amountToPay = (0, utils_1.getAmountToPay)(request, amount);
    return `bitcoin:${pn === null || pn === void 0 ? void 0 : pn.values.paymentAddress}?amount=${ethers_1.ethers.utils.formatUnits(amountToPay, 8)}`;
}
exports.getBtcPaymentUrl = getBtcPaymentUrl;
